export default __webpack_public_path__ + "static/media/desktopExtension.10030998.png";